export default __webpack_public_path__ + "static/banner-bg-25e3dc7f17b584c9187d8237eebc2c7e.png";